import { Button, Card, Col, Dropdown, Image, Row, Tag, Tooltip } from "antd";
import {
  AmountIcon,
  GreenCheckIcon,
  PenIcon,
  PlusIcon,
  StarFilledIcon,
} from "../../../../atoms/CustomIcons";
import { PopUp } from "../../../../atoms/PopUp";
import AddContactPopUp from "./PopUp";
import { useRef, useState } from "react";
import ConfirmDelete from "../../../../atoms/ConfirmDelete";
import { ErrorMessage } from "../../../../atoms/Toasts/ErrorMessage";
import { PhoneInput } from "react-international-phone";
import { MoreOutlined } from "@ant-design/icons";

interface PropsType {
  contacts: PopUpFormValues[];
  setContacts: React.Dispatch<React.SetStateAction<PopUpFormValues[]>>;
}

interface PopUpFormValues {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
  title: string;
  preferred_method_of_contact: string;
  is_starred?: boolean;
  is_signing?: boolean;
  is_billing?: boolean;
}

export default function AddContact(props: PropsType) {
  const { setContacts, contacts } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [contactIndex, setContactIndex] = useState<null | number>(null);
  const [tableRecord, setTableRecord] = useState<null | PopUpFormValues>(null);
  const dropdownRef = useRef<HTMLButtonElement>(null);
  // const [contactDetails, setContactDetails] = useState({
  //   starred: false,
  //   signing: false,
  //   billing: false,
  // });

  const myContactPopup = {
    visibility: isModalOpen,
    content: (
      <AddContactPopUp
        onClose={() => {
          setIsModalOpen(false);
          setContactIndex(null);
        }}
        setContacts={setContacts}
        contactIndex={contactIndex}
        setContactIndex={setContactIndex}
        contacts={contacts}
        editData={contactIndex !== null ? contacts?.[contactIndex] : null}
      />
    ),
    width: 541,
    onCancel: () => setIsModalOpen(false),
  };

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setIsModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          onClick={() => {
            setIsDeleteModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  console.log("contactIndex", contactIndex);

  const deleteFunction = () => {
    if (contactIndex !== null) {
      if (contactIndex < 0 || contactIndex >= contacts.length) {
        setContactIndex(null); // Clear the invalid index state
        return;
      }
      try {
        const updatedContacts = [
          ...contacts.slice(0, contactIndex),
          ...contacts.slice(contactIndex + 1),
        ];

        setContacts(updatedContacts);
        setIsDeleteModalOpen(false);
        setContactIndex(null);
        // SuccessMessage("Contact deleted");
      } catch (error) {
        console.error("Error deleting contact:", error);
        ErrorMessage("Failed to delete contact.");
      }
    } else {
      return;
    }
  };

  const deleteContactPopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          <>
            Are you sure you want to delete{" "}
            <b>{`${tableRecord?.first_name} ${tableRecord?.last_name}`}</b>?
            <br />
            <br />
            This action cannot be undone.
          </>
        }
        btnText="Delete contact"
        btnApi={deleteFunction}
        loading={false}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  const tagClassNames = [
    "mint_tag",
    "red_tag",
    "orange_tag",
    "purple_tag",
    "pink_tag",
    "violet_tag",
    "blue_tag",
    "yellow_tag",
  ];
  const contactTagColorsRef = useRef<string[]>([]);
  return (
    <Row gutter={20}>
      <Col span={24}>
        <h4 style={{ marginBottom: "4px" }}> Client contacts </h4>
        <p style={{ marginBottom: "16px" }}>
          People on the client’s side your team works and collaborates with.
        </p>

        {contacts?.length > 0 && (
          <Tooltip title="Add a client contact">
            <Button
              type="primary"
              className="outlined-btn"
              icon={<PlusIcon style={{ color: "#151718" }} />}
              onClick={() => setIsModalOpen(true)}
              style={{ position: "absolute", right: "10px", top: "0px" }}
            />
          </Tooltip>
        )}
      </Col>
      <Col span={24}>
        <div className="contact_wrapper">
          {contacts?.length > 0 ? (
            contacts?.map((e, i) => {
              if (!contactTagColorsRef.current[i]) {
                const randomIndex = Math.floor(
                  Math.random() * tagClassNames.length
                );
                contactTagColorsRef.current[i] = tagClassNames[randomIndex];
              }
              const randomClassName = contactTagColorsRef.current[i];
              return (
                <Card>
                  <div className="titleBar">
                    <span className="userName">
                      {`${e?.first_name} ${e?.last_name}`}
                    </span>
                    <div className="actionBtns">
                      <Button
                        type="text"
                        onClick={() => {
                          setContacts(
                            contacts.map((contact, index) =>
                              index === i
                                ? {
                                    ...contact,
                                    is_starred: !contact.is_starred,
                                  }
                                : contact
                            )
                          );
                        }}
                        className={
                          e?.is_starred
                            ? "activeIcon star"
                            : "notActiveIcon star"
                        }
                      >
                        <Tooltip title="The main point of contact from the client's side">
                          <StarFilledIcon />
                        </Tooltip>
                      </Button>
                      <Button
                        type="text"
                        onClick={() => {
                          setContacts(
                            contacts.map((contact, index) =>
                              index === i
                                ? {
                                    ...contact,
                                    is_signing: !contact.is_signing,
                                  }
                                : contact
                            )
                          );
                        }}
                        className={
                          e?.is_signing
                            ? "activeIcon sign"
                            : "notActiveIcon sign"
                        }
                      >
                        <Tooltip title="The contact responsible for signing documents and agreements">
                          <PenIcon />
                        </Tooltip>
                      </Button>
                      <Button
                        type="text"
                        onClick={() => {
                          setContacts(
                            contacts.map((contact, index) =>
                              index === i
                                ? {
                                    ...contact,
                                    is_billing: !contact.is_billing,
                                  }
                                : contact
                            )
                          );
                        }}
                        className={
                          e?.is_billing
                            ? "activeIcon invoice"
                            : "notActiveIcon invoice"
                        }
                      >
                        <Tooltip title="The contact responsible for handling invoices and payment-related communication">
                          <AmountIcon />
                        </Tooltip>
                      </Button>

                      <Dropdown
                        menu={{ items }}
                        trigger={["click"]}
                        placement="bottomRight"
                        className="actionButton"
                      >
                        <Button
                          onClick={(x) => {
                            x.stopPropagation();
                            setContactIndex(i);
                            setTableRecord(e);
                          }}
                          onKeyDown={(e) => e.stopPropagation()}
                          style={{
                            padding: "0px",
                            height: "auto",
                            border: "unset",
                            backgroundColor: "transparent",
                          }}
                          ref={dropdownRef}
                          className="only_icon"
                          icon={<MoreOutlined />}
                        />
                      </Dropdown>
                    </div>
                  </div>
                  <div style={{ marginBottom: "20px", height: "24px" }}>
                    {e?.title && (
                      <Tag
                        className={randomClassName}
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "inline-block",
                          minWidth: "auto",
                          maxWidth: "100%",
                        }}
                      >
                        {e?.title}{" "}
                      </Tag>
                    )}
                  </div>
                  <div className="contactData">
                    <span className="labelText">Phone:</span>
                    <span className="ValueText">
                      {e?.phone ? (
                        <>
                          <PhoneInput disabled value={e?.phone} />
                          {e?.preferred_method_of_contact === "phone" && (
                            <GreenCheckIcon />
                          )}
                        </>
                      ) : (
                        "-"
                      )}
                    </span>
                  </div>

                  <div className="contactData">
                    <span className="labelText">Email:</span>
                    <span className="ValueText">
                      {e?.email ? (
                        <>
                          <span className="truncatedEmail">
                            <Tooltip title={e.email}>
                              {e.email.length > 22
                                ? `${e.email.slice(0, 22)}...`
                                : e.email}
                            </Tooltip>
                          </span>
                          {e?.preferred_method_of_contact === "email" && (
                            <GreenCheckIcon
                              style={{
                                marginLeft: "4px",
                              }}
                            />
                          )}
                        </>
                      ) : (
                        "-"
                      )}
                    </span>
                  </div>
                </Card>
              );
            })
          ) : (
            <div className="whenEmpty">
              <Image src="/images/empty-icons/no-active.svg" preview={false} />
              <h3> There are no contacts </h3>
              <p> Click “+” to add a contact to this client. </p>
              <Button
                type="primary"
                className="outlined-btn btn-sm white_icon_btn"
                icon={<PlusIcon style={{ color: "#151718" }} />}
                onClick={() => setIsModalOpen(true)}
              >
                Add contact
              </Button>
            </div>
          )}

          <PopUp {...myContactPopup} />
          <PopUp {...deleteContactPopUp} />
        </div>
      </Col>
    </Row>
  );
}
